import { useTranslation } from "react-i18next";
import Social from "./Socials";

const Footer = (props) => {
  const { t } = useTranslation("clientSite");
  const site = props.site;

  const renderTime = (open, close) => {
    if (open === null || close === null) return t("closed");
    return `${open.hour}:${open.mins}-${close.hour}:${close.mins}`;
  };

  const address = [
    site.addressNumberName,
    site.addressFirstLine,
    site.addressSecondLine,
    site.addressCity,
    site.addressCounty,
    site.addressPostcode,
  ]
    .filter(Boolean)
    .join(", ");

  const mapUrl = address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    : null;

  return (
    <footer className="site-footer">
      <div className="site-container">
        <div className="site-footer__grid">
          <div className="site-footer__brandBlock">
            {/* <p className="site-footer__eyebrow">Contact</p> */}
            <h2 className="site-footer__title">{site.siteTitle}</h2>
            {site.email ? (
              <p className="site-footer__text">
                <a className="site-footer__link" href={`mailto:${site.email}`}>{site.email}</a>
              </p>
            ) : null}
            {site.phoneNumber ? (
              <p className="site-footer__text">
                <a className="site-footer__link" href={`tel:${site.phoneNumber}`}>{site.phoneNumber}</a>
              </p>
            ) : null}
            {address ? (
              <p className="site-footer__text">
                {address}
                {mapUrl ? (
                  <>
                    {" "}
                    ·{" "}
                    <a
                      className="site-footer__link"
                      href={mapUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("makeBooking:appointmentConfirmation.actions.getDirections")}
                    </a>
                  </>
                ) : null}
              </p>
            ) : null}
            <Social site={site} />
          </div>

          {site.showBusinessHours ? (
            <div className="site-footer__hoursCard">
              <h3 className="site-footer__hoursTitle">{t("openingHours")}</h3>
              <div className="site-footer__hoursList">
                <div><span>{t("day.monday")}</span><span>{renderTime(site.mondayOpen, site.mondayClose)}</span></div>
                <div><span>{t("day.tuesday")}</span><span>{renderTime(site.tuesdayOpen, site.tuesdayClose)}</span></div>
                <div><span>{t("day.wednesday")}</span><span>{renderTime(site.wednesdayOpen, site.wednesdayClose)}</span></div>
                <div><span>{t("day.thursday")}</span><span>{renderTime(site.thursdayOpen, site.thursdayClose)}</span></div>
                <div><span>{t("day.friday")}</span><span>{renderTime(site.fridayOpen, site.fridayClose)}</span></div>
                <div><span>{t("day.saturday")}</span><span>{renderTime(site.saturdayOpen, site.saturdayClose)}</span></div>
                <div><span>{t("day.sunday")}</span><span>{renderTime(site.sundayOpen, site.sundayClose)}</span></div>
              </div>
            </div>
          ) : null}
        </div>

        <div className="site-footer__bottom">
          <div className="site-footer__copy">© {new Date().getFullYear()} {site.siteTitle}</div>
          {props.children}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
